export default {
  set(key, value, expires = 0) {
    const jsTimestampShft = 100;
    let expiresDate = 0;

    if (expires) {
      expiresDate = ((Date.now() / jsTimestampShft) + expires) * jsTimestampShft;
    }

    const data = {
      expires: expiresDate,
      value,
    };

    window.localStorage.setItem(key, JSON.stringify(data));
  },

  remove(key) {
    window.localStorage.removeItem(key);
  },

  get(key) {
    let data = window.localStorage.getItem(key);

    if (data) {
      try {
        data = JSON.parse(data);
        if (data.expires !== 0 && data.expires < Date.now()) {
          this.remove(key);

          return '';
        }
      } catch (e) {
        window.console.error(`Невозможно извлечь данные по ключу ${key}`);

        return '';
      }

      return data.value;
    }

    return '';
  },
};
